import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {PopupAnchorRect} from '@Components/poster-editor/components/poster-popup-menu/poster-popup-menu.types';

interface StateProps {
  openPopup: boolean;
  /** The action bar's Replace button; the popup drops from it. */
  anchorRect: PopupAnchorRect | null;
}

const initialState: StateProps = {
  openPopup: false,
  anchorRect: null,
};

const imageItemPopUpMenu = createSlice({
  name: 'ImageItemPopUpMenu',
  initialState,
  reducers: {
    updateImagePopUpState: (state: StateProps, action: PayloadAction<StateProps>) => {
      state.openPopup = action.payload.openPopup;
      state.anchorRect = action.payload.anchorRect;
    },
  },
});

export const {updateImagePopUpState} = imageItemPopUpMenu.actions;
export const imageItemPopUpMenuReducer = imageItemPopUpMenu.reducer;
